<template>
  <div v-if="show" class="custom-modal-overlay">
    <div class="custom-modal">
      <div v-if="title" class="custom-modal-confirmation-title">{{ title }}</div>
      <div class="custom-modal-message">{{ message }}</div>
      <div v-if="subMessage" class="custom-modal-submessage">{{ subMessage }}</div>
      <div class="custom-modal-actions">
        <CustomButton :text="cancelLabel" variant="cancel" @click="$emit('cancel')" />
        <CustomButton :text="acceptLabel" variant="accept" @click="$emit('accept')" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import CustomButton from './CustomButton.vue'

defineProps({
  show: Boolean,
  title: String,
  message: String,
  acceptLabel: {
    type: String,
    default: 'Aceptar',
  },
  cancelLabel: {
    type: String,
    default: 'Cancelar',
  },
  subMessage: {
    type: String,
    default: '',
  },
})

defineEmits(['accept', 'cancel'])
</script>
<style scoped>
.custom-modal-submessage {
  margin-top: 8px;
  font-size: 14px;
  color: #020202;
}
</style>
